<template>
  <div class="card">
    <div class="card-body p-0">
      <div
        v-if="this.errosValidacaoGeral.length"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  {{ value }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisar"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid ps-15"
              placeholder="Pesquisar relatórios"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
          <button
            v-if="this.modulos"
            class="btn btn-sm btn-info"
            id="btnModulos"
            @click="consultarModulos()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen005.svg" /></span
            >Gerenciar Modulos
          </button>
          <button
            v-if="this.incluir"
            class="btn btn-sm btn-primary"
            id="btnAdicionar"
            @click="adicionarRelatorio()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/general/gen041.svg" /></span
            >Adicionar
          </button>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="tabelaRelatorios"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhum relatório encontrado"
          :colors="true"
          sortLabel="id"
          order="desc"
        >
          <template v-slot:cell-id="{ row: relatorios }">
            {{ relatorios.id }}
          </template>
          <template v-slot:cell-nome="{ row: relatorios }">
            {{ relatorios.nome }}
          </template>
          <template v-slot:cell-descricao="{ row: relatorios }">
            {{ relatorios.descricao }}
          </template>
          <template v-slot:cell-modulo="{ row: relatorios }">
            {{ relatorios.modulo }}
          </template>
          <template v-slot:cell-ativo="{ row: relatorios }">
            <span
              v-if="relatorios.ativo === '1'"
              class="badge badge-light-success"
              >Ativo</span
            >
            <span v-else class="badge badge-light-danger">Desativado</span>
          </template>
          <template v-slot:cell-acoes="{ row: relatorios }">
            <div class="d-flex justify-content-end flex-shrink-0">
              <button
                class="btn btn-sm btn-light btn-active-light-primary d-flex align-items-center"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
                tabindex="-1"
              >
                Ações
                <span class="svg-icon svg-icon-5 m-0">
                  <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
                </span>
              </button>
              <div
                class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
                data-kt-menu="true"
              >
                <div class="menu-item px-3" v-if="this.alterar">
                  <a @click="editarRelatorio(relatorios)" class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/art/art005.svg"
                        class="me-2"
                      />Editar
                    </span>
                  </a>
                </div>
                <div class="menu-item px-3" v-if="this.excluir">
                  <a
                    v-if="relatorios.padrao === '0'"
                    @click="excluirRelatorio(relatorios)"
                    class="menu-link px-3"
                    ><span class="svg-icon svg-icon-1 align-self-center">
                      <inline-svg
                        src="media/icons/duotune/arrows/arr015.svg"
                        class="me-2"
                      />Excluir
                    </span></a
                  >
                </div>
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalGerenciarNFe'"
    :mensagem="this.mensagemLoading"
    v-if="this.loading === true"
  ></LoadingModal>
  <EditarRelatorioModal
    v-if="exibirModalEditarRelatorio"
    :id="this.idRelatorio"
    @exibirEditarRelatorioModal="exibirEditarRelatorioModal"
    @confirmarEditarRelatorioModal="confirmarEditarRelatorioModal"
  >
  </EditarRelatorioModal>
  <ConsultarModulosModal
    v-if="exibirModalConsultarModulos"
    @exibirConsultarModulosModal="exibirConsultarModulosModal"
  >
  </ConsultarModulosModal>
</template>

<script>
import {
  getOrCreateInstanceModal,
  hideModalId,
  hideModal,
} from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { mapState } from "vuex";
import EditarRelatorioModal from "@/views/relatorios/EditarRelatorioModal.vue";
import ConsultarModulosModal from "@/views/relatorios/ConsultarModulosModal.vue";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  components: {
    Datatable,
    LoadingModal,
    EditarRelatorioModal,
    ConsultarModulosModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Relatorios.Incluir") {
            this.incluir = true;
          }
          if (element.regra === "Permitir.Relatorios.Alterar") {
            this.alterar = true;
          }
          if (element.regra === "Permitir.Relatorios.Excluir") {
            this.excluir = true;
          }
          if (element.regra === "Permitir.RelatoriosModulos.Consultar") {
            this.modulos = true;
          }
        });
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },

    async confirmarEditarRelatorioModal() {
      this.$refs.tabelaRelatorios.setLoading(true);
      this.$refs.tabelaRelatorios.load();
      this.exibirModalEditarRelatorio = false;
    },

    exibirEditarRelatorioModal(exibir) {
      this.exibirModalEditarRelatorio = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_relatorios_editar",
          /*open*/ () => {
            this.$utils.requestFocus("txtNome");
          },
          /*close*/ () => {
            this.exibirEditarRelatorioModal(false);
          }
        );
      }
    },

    exibirConsultarModulosModal(exibir) {
      this.exibirModalConsultarModulos = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_consultar_relatorios_modulos_modal",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisar");
          },
          /*close*/ () => {
            this.exibirConsultarModulosModal(false);
          }
        );
      }
    },

    async adicionarRelatorio() {
      this.idRelatorio = -1;
      this.exibirEditarRelatorioModal(true);
    },

    async consultarModulos() {
      this.exibirConsultarModulosModal(true);
    },

    async editarRelatorio(relatorio) {
      this.idRelatorio = relatorio.id;
      this.exibirEditarRelatorioModal(true);
    },

    async excluirRelatorio(relatorio) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            try {
              this.$refs.tabelaRelatorios.setLoading(true);

              var ret = await this.$store.dispatch(
                "relatorios/deleteRelatorios",
                relatorio.id
              );

              if (ret.Success == true) {
                toast.success("Registro removido com sucesso!", {
                  timeout: 2000,
                });
                this.$refs.tabelaRelatorios.load();
              }
            } catch (error) {
              console.log(error);
            }
            this.$refs.tabelaRelatorios.setLoading(false);
          }
        }
      );
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisar");
    }, 800);
  },
  data() {
    return {
      loading: false,
      incluir: false,
      alterar: false,
      excluir: false,
      modulos: false,
      errosValidacaoGeral: [],
      exibirModalEditarRelatorio: false,
      refRelatorioEdicao: {},
      idRelatorio: -1,
      exibirModalConsultarModulos: false,
      tableHeader: [
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "nome",
          key: "nome",
          sortingField: "nome",
          sortable: true,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortingField: "descricao",
          sortable: true,
        },
        {
          name: "Módulo",
          key: "modulo",
          sortable: true,
        },
        {
          name: "ativo",
          key: "ativo",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "relatorios/getRelatoriosOData",
        selectOData: "?$select=id,nome,descricao,modulo,ativo,padrao",
        filterOData: "&$filter=tipo_relatorio eq '0'",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100"],
    };
  },
};
</script>

<style></style>
